export enum TicketOperationTaskStatus {
    NEW = "New",
    RESOLVED = "Resolved",
    UNRESOLVED = "Unresolved"
}
